/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateCompetitionBodyItemsInner } from './CreateCompetitionBodyItemsInner';
import {
    CreateCompetitionBodyItemsInnerFromJSON,
    CreateCompetitionBodyItemsInnerFromJSONTyped,
    CreateCompetitionBodyItemsInnerToJSON,
    CreateCompetitionBodyItemsInnerToJSONTyped,
} from './CreateCompetitionBodyItemsInner';
import type { CreateCompetitionBodyRecurrence } from './CreateCompetitionBodyRecurrence';
import {
    CreateCompetitionBodyRecurrenceFromJSON,
    CreateCompetitionBodyRecurrenceFromJSONTyped,
    CreateCompetitionBodyRecurrenceToJSON,
    CreateCompetitionBodyRecurrenceToJSONTyped,
} from './CreateCompetitionBodyRecurrence';
import type { CreateCompetitionBodyFaqsInner } from './CreateCompetitionBodyFaqsInner';
import {
    CreateCompetitionBodyFaqsInnerFromJSON,
    CreateCompetitionBodyFaqsInnerFromJSONTyped,
    CreateCompetitionBodyFaqsInnerToJSON,
    CreateCompetitionBodyFaqsInnerToJSONTyped,
} from './CreateCompetitionBodyFaqsInner';
import type { CreateCompetitionBodyOnboardingSection } from './CreateCompetitionBodyOnboardingSection';
import {
    CreateCompetitionBodyOnboardingSectionFromJSON,
    CreateCompetitionBodyOnboardingSectionFromJSONTyped,
    CreateCompetitionBodyOnboardingSectionToJSON,
    CreateCompetitionBodyOnboardingSectionToJSONTyped,
} from './CreateCompetitionBodyOnboardingSection';

/**
 * 
 * @export
 * @interface CreateCompetitionBody
 */
export interface CreateCompetitionBody {
    /**
     * 
     * @type {string}
     * @memberof CreateCompetitionBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompetitionBody
     */
    description?: string;
    /**
     * 
     * @type {Array<CreateCompetitionBodyItemsInner>}
     * @memberof CreateCompetitionBody
     */
    items?: Array<CreateCompetitionBodyItemsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCompetitionBody
     */
    isRecurring?: boolean;
    /**
     * 
     * @type {CreateCompetitionBodyRecurrence}
     * @memberof CreateCompetitionBody
     */
    recurrence?: CreateCompetitionBodyRecurrence;
    /**
     * 
     * @type {string}
     * @memberof CreateCompetitionBody
     */
    eventName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompetitionBody
     */
    sponsorId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompetitionBody
     */
    ruleSetId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompetitionBody
     */
    hero?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompetitionBody
     */
    banner?: string;
    /**
     * 
     * @type {CreateCompetitionBodyOnboardingSection}
     * @memberof CreateCompetitionBody
     */
    onboardingSection?: CreateCompetitionBodyOnboardingSection;
    /**
     * 
     * @type {Array<CreateCompetitionBodyFaqsInner>}
     * @memberof CreateCompetitionBody
     */
    faqs?: Array<CreateCompetitionBodyFaqsInner>;
    /**
     * How the competition is displayed — "embedded" (inline platform) or "microsite" (standalone slug URL)
     * @type {string}
     * @memberof CreateCompetitionBody
     */
    displayMode?: string;
    /**
     * URL slug used when displayMode is "microsite" (e.g. "apex-legends-invitational")
     * @type {string}
     * @memberof CreateCompetitionBody
     */
    micrositeSlug?: string;
}

/**
 * Check if a given object implements the CreateCompetitionBody interface.
 */
export function instanceOfCreateCompetitionBody(value: object): value is CreateCompetitionBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateCompetitionBodyFromJSON(json: any): CreateCompetitionBody {
    return CreateCompetitionBodyFromJSONTyped(json, false);
}

export function CreateCompetitionBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCompetitionBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(CreateCompetitionBodyItemsInnerFromJSON)),
        'isRecurring': json['isRecurring'] == null ? undefined : json['isRecurring'],
        'recurrence': json['recurrence'] == null ? undefined : CreateCompetitionBodyRecurrenceFromJSON(json['recurrence']),
        'eventName': json['eventName'] == null ? undefined : json['eventName'],
        'sponsorId': json['sponsorId'] == null ? undefined : json['sponsorId'],
        'ruleSetId': json['ruleSetId'] == null ? undefined : json['ruleSetId'],
        'hero': json['hero'] == null ? undefined : json['hero'],
        'banner': json['banner'] == null ? undefined : json['banner'],
        'onboardingSection': json['onboardingSection'] == null ? undefined : CreateCompetitionBodyOnboardingSectionFromJSON(json['onboardingSection']),
        'faqs': json['faqs'] == null ? undefined : ((json['faqs'] as Array<any>).map(CreateCompetitionBodyFaqsInnerFromJSON)),
        'displayMode': json['displayMode'] == null ? undefined : json['displayMode'],
        'micrositeSlug': json['micrositeSlug'] == null ? undefined : json['micrositeSlug'],
    };
}

export function CreateCompetitionBodyToJSON(json: any): CreateCompetitionBody {
    return CreateCompetitionBodyToJSONTyped(json, false);
}

export function CreateCompetitionBodyToJSONTyped(value?: CreateCompetitionBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(CreateCompetitionBodyItemsInnerToJSON)),
        'isRecurring': value['isRecurring'],
        'recurrence': CreateCompetitionBodyRecurrenceToJSON(value['recurrence']),
        'eventName': value['eventName'],
        'sponsorId': value['sponsorId'],
        'ruleSetId': value['ruleSetId'],
        'hero': value['hero'],
        'banner': value['banner'],
        'onboardingSection': CreateCompetitionBodyOnboardingSectionToJSON(value['onboardingSection']),
        'faqs': value['faqs'] == null ? undefined : ((value['faqs'] as Array<any>).map(CreateCompetitionBodyFaqsInnerToJSON)),
        'displayMode': value['displayMode'],
        'micrositeSlug': value['micrositeSlug'],
    };
}

